import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { EQUIPMENT } from '../data/site';
import { Seo } from '../lib/seo';
import { Reveal } from '../components/motion';
import { PageHero, CTABand, Breadcrumbs } from '../components/chrome';

const crumbs = [
  { label: 'Home', href: '/' },
  { label: 'Equipment' },
];

export default function EquipmentHub() {
  return (
    <div data-testid="page-equipment-hub">
      <Seo
        title="Analytical & Laboratory Equipment Categories | ToxGlobal Analytics"
        description="Browse 18 categories of analytical and laboratory equipment supplied, installed, and supported by ToxGlobal Analytics: GC/MS, FTIR, Raman, XRF, gas detection, air monitoring, chemistry analyzers, and more."
        path="/equipment"
        breadcrumbs={crumbs}
      />
      <PageHero
        eyebrow="Equipment"
        lines="Equipment categories, sourced to specification"
        sub="Eighteen categories of analytical instrumentation and laboratory equipment — procured through OEM and authorized-distributor channels, delivered, installed, and supported nationwide. Every category can be quoted for government purchase card, PO, or RFQ workflows."
        breadcrumbs={crumbs}
        image={EQUIPMENT[0].image}
        imageAlt={EQUIPMENT[0].alt}
      />
      <section className="section-pad" data-testid="equipment-grid">
        <div className="container-x grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {EQUIPMENT.map((e, i) => (
            <Reveal key={e.slug} delay={Math.min(i * 0.03, 0.3)} className="bg-white">
              <Link to={`/equipment/${e.slug}`} className="group flex flex-col h-full" data-testid={`equipment-card-${e.slug}`}>
                <div className="overflow-hidden aspect-[16/10] bg-midnight">
                  <img src={e.image} alt={e.alt} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col grow">
                  <p className="font-mono text-[11px] text-slate-400 tabular">{String(i + 1).padStart(2, '0')}</p>
                  <h2 className="display text-xl text-ink mt-2 group-hover:text-signal transition-colors">{e.name}</h2>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed grow">{e.tagline}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-signal">
                    View category <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <div className="container-x mt-10">
          <Reveal>
            <p className="text-sm text-slate-500 max-w-2xl">
              Need a platform that isn't listed? ToxGlobal sources brand-specific instrumentation through its OEM and
              authorized-distributor network. <Link to="/contact" className="text-signal link-sweep font-medium" data-testid="equipment-hub-source-link">Source an instrument <ArrowUpRight size={13} className="inline" /></Link>
            </p>
          </Reveal>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
